import styled, { css } from 'styled-components';

export const ActionPlanListContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 100px ${({ theme }) => theme.spacing.sm};
  margin-bottom: 88px;
  row-gap: ${({ theme }) => theme.spacing.m};
  margin-top: 140px;
`;

export const PillContainer = styled.div`
  height: 40px;
  border-radius: 64px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow: hidden;
  background-color: rgba(51, 51, 51, 0.1);
  padding: 4px;
`;

export const Pill = styled.div(
  ({ checked, theme }) => css`
    display: flex;
    flex: 1;
    position: relative;
    justify-content: center;
    align-items: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    background-color: ${checked && theme.colors.white};
    border-radius: 64px;
    color: ${checked && '#4fada6'};
  `
);

export const TableContainer = styled.div`
  width: 100%;
`;

export const StyledTable = styled.table`
  width: 100%;
  text-align: left;
  & th:nth-child(1),
  & td:nth-child(1) {
    width: 30%;
  }

  & th:nth-child(2),
  & td:nth-child(2) {
    width: 25%;
  }
  & th:nth-child(3),
  & td:nth-child(3) {
    width: 30%;
  }
  & th:nth-child(4),
  & td:nth-child(4) {
    width: 15%;
  }
`;

export const TableHeader = styled.th`
  padding: 10px;
`;

export const TableCell = styled.td`
  padding: 10px;
`;

export const TableRow = styled.tr`
  box-shadow:
    rgba(0, 0, 0, 0.1) 0px 0.3px 0.9px,
    rgba(0, 0, 0, 0.13) 0px 1.6px 3.6px;
  border-radius: 0.25rem;
`;

export const TableHead = styled.thead``;

export const HeaderTableRow = styled.tr``;

export const TableBody = styled.tbody``;

export const FilterContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

export const DepartmentHeaderContainer = styled.div`
  align-items: baseline;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spacing.s};
`;

export const CreateButtonContainer = styled.div`
  margin: ${({ theme }) => theme.spacing.m};
`;

export const FilterContentWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.m};
`;

export const FilterLabelWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.s};
`;
